import ConditionalToolTip from "components/design/conditionalToolTip";
import { Button } from "components/DesignSystem/Button/Button";
import { CountBadge } from "components/DesignSystem/Tag/CountBadge";
import { AIOutlinedIcon } from "components/icons/AIOutlinedIcon";
import { LinkInkleBillModal } from "components/LinkInkleBillModal/LinkInkleBillModal";
import { LinkInkleInvoiceModal } from "components/LinkInkleInvoiceModal/LinkInkleInvoiceModal";
import { useModal } from "hooks/useModal";
import { useCurrentEntityId } from "hooks/useCurrentEntityId";
import { useGetSuggestedInvoicesQuery } from "store/apis/transactions";
import { Transactions } from "types/Models/books";
import { pluralize } from "utils/pluralize";

export const SuggestedInvoiceBillColumn = ({
  transactionDetails,
  hasWritePermission,
}: {
  transactionDetails: Transactions;
  hasWritePermission: boolean;
}) => {
  const entityId = useCurrentEntityId();
  const transactionId = transactionDetails.transaction.uuid;
  const linkInkleInvoiceModal = useModal();
  const linkInkleBillModal = useModal();

  const hasSuggestedInvoiceBill = transactionDetails.has_suggested_invoice_bill;
  const isDebit =
    transactionDetails.transaction.amount &&
    transactionDetails.transaction.amount < 0;

  const { data } = useGetSuggestedInvoicesQuery(
    { entityId, transactionId },
    {
      skip: !entityId || !transactionId || !hasSuggestedInvoiceBill,
    }
  );

  const suggestionCount = data?.suggested_invoices?.length ?? 0;

  if (!hasWritePermission || !suggestionCount) {
    return null;
  }

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (isDebit) {
      linkInkleBillModal.open();
    } else {
      linkInkleInvoiceModal.open();
    }
  };

  return (
    <div
      className="t-flex t-justify-center t-items-center"
      onClick={(e) => e.stopPropagation()}
    >
      <ConditionalToolTip
        condition={`Inkle AI found ${pluralize(
          suggestionCount,
          "potential payment match",
          "potential payment matches"
        )}`}
      >
        <div className="t-relative t-inline-flex">
          <Button customType="ghost" size="small" onClick={handleClick}>
            <AIOutlinedIcon />
          </Button>
          <CountBadge count={suggestionCount} />
        </div>
      </ConditionalToolTip>

      {linkInkleInvoiceModal.isOpen && (
        <LinkInkleInvoiceModal
          transactionId={transactionId}
          isOpen={linkInkleInvoiceModal.isOpen}
          close={linkInkleInvoiceModal.close}
        />
      )}

      {linkInkleBillModal.isOpen && (
        <LinkInkleBillModal
          transactionId={transactionId}
          isOpen={linkInkleBillModal.isOpen}
          close={linkInkleBillModal.close}
        />
      )}
    </div>
  );
};
